import { useFormikContext } from "formik";
import React, { useEffect } from "react";
var ValidationDetector = function ValidationDetector(props) { var formik = useFormikContext(); useEffect(function () { if (!formik.isValid) {
    var _props$onError;
    (_props$onError = props.onError) === null || _props$onError === void 0 ? void 0 : _props$onError.call(props, formik.errors);
} }, [formik.errors]); return /*#__PURE__*/ React.createElement(React.Fragment, null); };
export default ValidationDetector;
